const sidebar = Object.freeze({
  CONTENT_WIDTH: '70px',
  CONTENT_WIDTH_OPEN: '225px',
});

export default sidebar;
